<template>
  <v-row dense>
    <v-col cols="12">
      <v-menu
        ref="menuExpiryDate"
        min-width="290px"
        transition="scale-transition"
        :close-on-content-click="false"
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :value="form.expiry_date | dateFormat"
            readonly
            clearable
            role="button"
            autocomplete="nope"
            append-icon="mdi-calendar"
            :label="$t('DEVICES.EXPIRY_DATE')"
            :error-messages="errors.expiry_date"
            :rules="getRulesByName('expiry_date')"
            @click:clear="clearExpiryDate"
            v-on="on"
          />
        </template>
        <v-date-picker
          v-model="expiry_date"
          :min="minExpiryDate"
          first-day-of-week="1"
          @change="saveExpiryDate"
        />
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
import moment from 'moment';
import formEditable from '@/modules/_global/mixins/form-editable';
import { dateFormat, dateFormatBackend } from '@/modules/_global/filters';
import { maxDaysAgoCancelNotruf } from '@/modules/_global/config';

export default {
  name: 'DeviceForm',

  filters: {
    dateFormat
  },

  mixins: [formEditable],

  data() {
    return {
      form: {
        expiry_date: null,
        date_registration: null
      }
    };
  },

  computed: {
    expiry_date: {
      get() {
        return dateFormatBackend(this.form.expiry_date);
      },
      set(v) {
        this.form.expiry_date = v;
      }
    },

    maxDateBefore() {
      return dateFormatBackend(
        moment().subtract(maxDaysAgoCancelNotruf + 1, 'days')
      );
    },

    compareDates() {
      return [this.maxDateBefore, this.form.date_registration].filter(Boolean);
    },

    maxCompareDate() {
      return this.compareDates.map(dateFormatBackend).reduce(function(a, b) {
        return a > b ? a : b;
      });
    },

    minExpiryDate() {
      const maxDateAfter = moment(this.maxCompareDate).add(1, 'days');

      return dateFormatBackend(maxDateAfter);
    }
  },

  methods: {
    clearExpiryDate() {
      this.expiry_date = null;
      this.updateValue('expiry_date', null);
    },

    saveExpiryDate(date) {
      this.$refs.menuExpiryDate.save(date);
      this.updateValue('expiry_date', date);
    }
  }
};
</script>
